import { styled } from '@mui/material/styles'
import { AppButton, Content, TextField } from '@/components/ui'
import { Typography, TypographyProps, Link } from '@mui/material'
import Grid from '@mui/material/Grid2'

export const MainContent = styled(Content)`
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.only('xs')} {
    padding: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(2)};
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.palette.common.white};
    top: -30px;
    overflow-y: auto;
    height: calc(100% - 170px);
  }
`

export const OptInMessage = styled(Typography)<TypographyProps>`
  color: ${({ theme }) => theme.custom.colors.common.grey2};
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  margin-top: -12px;
`

export const OptInLink = styled(Link)`
  color: ${({ theme }) => theme.custom.colors.common.grey2};
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.black};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 300px;
  height: 100%;
  margin: 0 auto;

  ${({ theme }) => theme.breakpoints.only('xs')} {
    width: 100%;
    height: calc(100vh - 158px);
  }
`

export const Input = styled(TextField)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`

export const NextButton = styled(AppButton)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`

export const InputGrid = styled(Grid)`
  flex: 1;
`

export const ProgressGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: ${({ theme }) => theme.spacing(5)};
`

export const FormGrid = styled(Grid)`
  height: 100%;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-top: ${({ theme }) => theme.spacing(2)};
  }
`

export const OrganizationName = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.grey3};
`
